import { FunctionComponent } from 'react';
import { Routes, Route } from 'react-router-dom';
import ClientProfile from 'src/pages/dashboard/consultant/ClientProfile';
import Clients from 'src/pages/dashboard/consultant/Clients';
import CreditPullApplication from 'src/pages/dashboard/consultant/CreditPullApplication';

const ConsultantRoutes: FunctionComponent = () => (
    <Routes>
        <Route path='/clients' element={<Clients />} />
        <Route path='/clients/:id' element={<ClientProfile />} />
        <Route path='/clients/:id/apps/:appId' element={<CreditPullApplication />} />
    </Routes>
);

export default ConsultantRoutes;